module.exports = __webpack_public_path__ + "static/media/pawritten.40b65932.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten.eot
// module id = ./src/assets/fonts/pawritten.eot
// module chunks = 6